import React from 'react';
import { View, Text } from 'react-native';
import ar from '../images/screen_ar.png';
import en from '../images/screen_en.png';
const screen = { ar, en };

const styles = {
    alig: {
        //alignItems: 'center',
        justifyContent: 'center',
        width: 400,
        paddingHorizontal: 10
    },
    tag_line: {
        textAlign: 'center',
        color: '#AAA',
        marginBottom: 20,
        flex: 1
    },
    link: {
        color: '#578bc1',
        marginBottom: '15px',
        fontSize: 18,
        textDecoration: 'none'
    },
    description: {
        color: '#CCC',
        lineHeight: 20,
        marginBottom: 50
    }
};

const DownLink = ({ icon, text, link }) => (
    <a href={link} style={styles.link} target={'_blank'}>
        <span className={icon} style={{ margin: '0 9px 0 9px' }} />
        {text}
    </a>
);
export const HOME = ({ lang }) => (
    <View style={{ flexDirection: 'row', flex: 1, flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>
        <View style={styles.alig}>
            <Text style={[styles.tag_line, lang.CODE == 'en' ? { fontSize: 20 } : { fontSize: 28, paddingHorizontal: 40 }]}>{lang.TAG_LINE}</Text>
            <Text style={[styles.description, lang.CODE == 'en' ? { fontSize: 14 } : { fontSize: 14 }]}>{lang.DESCRIPTION}</Text>
            <View style={{ marginBottom: 50 }}>
                <DownLink icon="icon-apple" text={lang.IPHONE} link={'https://fosol.com/iphone'} />
                <DownLink icon="icon-android-logo" text={lang.ANDROID} link={'https://fosol.com/android'} />
                <DownLink icon="icon-com-mac2" text={lang.WEB_APP} link={'https://fosol.com/web'} />
            </View>
        </View>
        <View style={[styles.alig, { alignItems: 'center' }]}>
            <img src={screen[lang.CODE]} style={{ display: 'flex', width: '100%', maxWidth: '280px' }} />
        </View>
    </View>
);



// WEBPACK FOOTER //
// ./src/comp/pages/home.js